import { Outlet } from "react-router-dom";
import { Sidebar } from "../ui/Sidebar";
import { AlertWatcher } from "../features/alerts/AlertWatcher";

export default function Layout() {
  return (
    <div className="app">
      <Sidebar />
      <main className="main">
        <div className="container">
          <Outlet />
        </div>
      </main>
      <AlertWatcher />
    </div>
  );
}
